(function () {
  var root = document.querySelector('[data-mechanism-video]');
  if (!root) return;

  var openBtn = root.querySelector('.js-mechanism-video-open');
  var modal = root.querySelector('[data-mechanism-video-modal]');
  var backdrop = root.querySelector('[data-mechanism-video-backdrop]');
  var closeBtn = root.querySelector('[data-mechanism-video-close]');
  var dialog = document.getElementById('MechanismVideoDialog');
  var video = root.querySelector('[data-mechanism-video-player]');
  if (!openBtn || !modal || !backdrop || !closeBtn || !dialog || !video) return;

  var previousOverflow = '';
  var isOpen = false;

  function focusables() {
    return [closeBtn, video];
  }

  function pauseAndReset() {
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {}
  }

  function openModal() {
    if (isOpen) return;
    isOpen = true;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    dialog.focus();
    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () {});
    }
  }

  function closeModal() {
    if (!isOpen) return;
    isOpen = false;
    pauseAndReset();
    document.body.style.overflow = previousOverflow;
    modal.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus();
  }

  openBtn.addEventListener('click', function (event) {
    event.preventDefault();
    openModal();
  });

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (event) {
    if (!isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    var nodes = focusables();
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey) {
      if (document.activeElement === first || document.activeElement === dialog) {
        event.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
